import React from 'react';

export const Integration = (integrations, integration, action) => {
	const Component = integrations[integration.type];

	return <Component key={integration.id} integration={integration} action={action} />;
};
